import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ButtonGroup} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Select from "react-select";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

export default class TimeTracking extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Activity_Logs._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 25;
		this.state.filterDate = moment().format();
		this.state.dayFilter = true;
	}

	fetchData = async (state) => {
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.sorted = [];
		this.state.filter.filterDate = this.state.filterDate;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	handleDaySelect = async (event) => {
		let date = null;
		let currentDate = this.state.filterDate;
		switch (event.currentTarget.id) {
			case 'sub':
				date = moment(currentDate).subtract(1, 'day').format()
				break;
			case 'add':
				date = moment(currentDate).add(1, 'day').format()
				break;
			case 'today':
				date = moment().format();
				break;
		}
		await this.setState({filterDate: date});
		await this.fetchData(this.state);
	}

	showDatePicker = () => {
		this.setState({showDate: true})
	}

	toggleClose = () => {
		this.setState({showDate: false})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		this.toggleClose();
		await this.fetchData(this.state);
	}


	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Activity",
				id: "activity_types.activity_name",
				/** @param {Time_Off_Object} obj */
				accessor: obj => (obj.activity_types.activity_name)
			},
			{
				Header: "Recorded At",
				id: "created",
				/** @param {Time_Off_Object} obj */
				accessor: obj => (moment(obj.created).format("hh:mm:ss A"))
			}
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className={'row'} style={{marginLeft: 0}}>
							<div className={"col-3"} style={{display: "flex", fontSize: 20, justifyContent: "left"}}>
								<div className={"row rbc-toolbar"} style={{marginLeft: 0}}>
									<div className={"rbc-btn-group"}>
										<Button id={'sub'} onClick={this.handleDaySelect}><LeftArrowIcon/></Button>
										<Button id={'today'} onClick={this.handleDaySelect}>Today</Button>
										<Button id={'add'} onClick={this.handleDaySelect}><RightArrowIcon/></Button>
									</div>
									<div className={"rbc-toolbar-label"}>
										<label onClick={this.showDatePicker}>
											{moment(this.state.filterDate).format('dddd MMM D')}
										</label>
									</div>
								</div>
							</div>
							{/*<div className={'col-1'}>
								<ButtonGroup size={"md"}>
									<Button
										onClick={() => {this.setState({dayFilter: true}, () => {this.fetchData(this.state)})}}
										outline={this.state.dayFilter !== true}
										active={this.state.dayFilter === true}
									>
										Day
									</Button>
									<Button
										onClick={() => {this.setState({dayFilter: false}, () => {this.fetchData(this.state)})}}
										outline={this.state.dayFilter !== false}
										active={this.state.dayFilter === false}
									>
										Week
									</Button>
								</ButtonGroup>
							</div>
							<div className={'col-5'}>
								<b>Select a user to view a detailed history of a day or a day by day view of a week. Click a user's name to quickly filter by them.</b>
							</div>*/}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<Modal
						isOpen={this.state.showDate}
						toggle={this.toggleClose}
						size={"sm"}
						backdrop={true}
						style={{display: "none"}}
					>
						<ModalBody>
							<Framework.Elements.Date
								label={"Custom Date"}
								value={this.state.filterDate}
								update={this.handleDateChange}
								open={this.state.showDate}
								clearable={false}
								cancelLabel={''}
							/>
						</ModalBody>
					</Modal>
				</CardContent>
			</Card>
		)
	}
}
